<template>
  <RouterView name="footer" class="container grow print:mx-0 print:min-w-full" />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>
